// Users.js
const users = {
    "A1B2C3": {
        uniqueId: "123456",
        idCreationDate: "2023-06-01",
        idNumber: "A1B2C3",
        firstName: "Alex",
        lastName: "Johnson",
        dateOfBirth: "1990-04-15",
        gender: { value: 'male', label: 'Male' },
        nationality: { value: 'canadian', label: 'Canadian' },
        ethnicity: { value: 'caucasian', label: 'Caucasian' },
        languages: [{ value: 'english', label: 'English' }, { value: 'french', label: 'French' }],
        exerciseFrequency: { value: 'moderate', label: 'Moderate' },
        diet: { value: 'balanced', label: 'Balanced' },
        sleepPatterns: { value: 'regular', label: 'Regular' },
        alcoholConsumption: { value: 'low', label: 'Low' },
        smokingHabits: "Non-smoker",
        knownConditions: "None",
        allergies: "Pollen",
        medications: "None",
        vaccinationStatus: "Up-to-date",
        workStressLevel: { value: 'medium', label: 'Medium' },
        personalStressLevel: { value: 'low', label: 'Low' },
        financialStressLevel: { value: 'low', label: 'Low' },
        familyStructure: "Single",
        workEnvironment: { value: 'office', label: 'Office' },
        relationshipStatus: "Single",
        socialSupport: { value: 'strong', label: 'Strong' },
        communityEngagement: { value: 'active', label: 'Active' },
        therapyHistory: "No",
        majorLifeEvents: "Graduated university, Moved to a new city",
        emotionalWellBeing: { value: 'stable', label: 'Stable' },
        // Add biometric data fields as needed
        heartRate: 85.34,
        breathingRate: 18.59,
        hrv: 58.39,
        skinTemp: 33.76,
        emg: 0.47,
        bvp: 0.89,
        emotion: 'Surprised',
    },
    "B1C2D3": {
        uniqueId: "556677",
        idCreationDate: "2023-12-01",
        idNumber: "B1C2D3",
        firstName: "Clara",
        lastName: "Schmidt",
        dateOfBirth: "33074", // This might need conversion to a standard date format
        gender: { value: 'female', label: 'Female' },
        nationality: { value: 'german', label: 'German' },
        ethnicity: { value: 'caucasian', label: 'Caucasian' },
        languages: [{ value: 'german', label: 'German' }, { value: 'english', label: 'English' }],
        exerciseFrequency: { value: 'high', label: 'High' },
        diet: { value: 'balanced', label: 'Balanced' },
        sleepPatterns: { value: 'regular', label: 'Regular' },
        alcoholConsumption: { value: 'low', label: 'Low' },
        smokingHabits: "Non-smoker",
        knownConditions: "None",
        allergies: "None",
        medications: "None",
        vaccinationStatus: "Up-to-date",
        workStressLevel: { value: 'medium', label: 'Medium' },
        personalStressLevel: { value: 'low', label: 'Low' },
        financialStressLevel: { value: 'low', label: 'Low' },
        familyStructure: "In a relationship",
        workEnvironment: { value: 'hybrid', label: 'Hybrid' },
        relationshipStatus: "In a relationship",
        socialSupport: { value: 'strong', label: 'Strong' },
        communityEngagement: { value: 'active', label: 'Active' },
        therapyHistory: "No",
        majorLifeEvents: "Recent marriage, Promotion at work",
        emotionalWellBeing: { value: 'stable', label: 'Stable' },
        // Add biometric data fields as needed
        heartRate: 99.80,
        breathingRate: 22.62,
        hrv: 46.97,
        skinTemp: 33.07,
        emg: 0.47,
        bvp: 1.02,
        emotion: 'Anxious',
    },
    "D4E5F6": {
        uniqueId: "789101",
        idCreationDate: "2023-01-15",
        idNumber: "D4E5F6",
        firstName: "Maria",
        lastName: "Garcia",
        dateOfBirth: "1985-09-21",
        gender: { value: 'female', label: 'Female' },
        nationality: { value: 'spanish', label: 'Spanish' },
        ethnicity: { value: 'hispanic', label: 'Hispanic' },
        languages: [{ value: 'spanish', label: 'Spanish' }, { value: 'english', label: 'English' }],
        exerciseFrequency: { value: 'high', label: 'High' },
        diet: { value: 'vegetarian', label: 'Vegetarian' },
        sleepPatterns: { value: 'irregular', label: 'Irregular' },
        alcoholConsumption: { value: 'moderate', label: 'Moderate' },
        smokingHabits: "Former smoker",
        knownConditions: "Hypertension",
        allergies: "None",
        medications: "Antihypertensives",
        vaccinationStatus: "Up-to-date",
        workStressLevel: { value: 'high', label: 'High' },
        personalStressLevel: { value: 'medium', label: 'Medium' },
        financialStressLevel: { value: 'medium', label: 'Medium' },
        familyStructure: "Married",
        workEnvironment: { value: 'hybrid', label: 'Hybrid' },
        relationshipStatus: "Married",
        socialSupport: { value: 'moderate', label: 'Moderate' },
        communityEngagement: { value: 'moderate', label: 'Moderate' },
        therapyHistory: "Yes",
        majorLifeEvents: "Marriage, Recent job change",
        emotionalWellBeing: { value: 'variable', label: 'Variable' },
        // Add biometric data fields as needed
        heartRate: 75.00,
        breathingRate: 15.68,
        hrv: 52.40,
        skinTemp: 32.26,
        emg: 0.25,
        bvp: 0.76,
        emotion: 'Happy',
    },
    "E3F4G5": {
        uniqueId: "778899",
        idCreationDate: "2024-01-15",
        idNumber: "E3F4G5",
        firstName: "Hiroshi",
        lastName: "Takahashi",
        dateOfBirth: "1985-10-31",
        gender: { value: 'male', label: 'Male' },
        nationality: { value: 'japanese', label: 'Japanese' },
        ethnicity: { value: 'eastAsian', label: 'East Asian' },
        languages: [{ value: 'japanese', label: 'Japanese' }, { value: 'english', label: 'English' }],
        exerciseFrequency: { value: 'high', label: 'High' },
        diet: { value: 'balanced', label: 'Balanced' },
        sleepPatterns: { value: 'regular', label: 'Regular' },
        alcoholConsumption: { value: 'moderate', label: 'Moderate' },
        smokingHabits: "Non-smoker",
        knownConditions: "None",
        allergies: "Seafood",
        medications: "None",
        vaccinationStatus: "Up-to-date",
        workStressLevel: { value: 'medium', label: 'Medium' },
        personalStressLevel: { value: 'medium', label: 'Medium' },
        financialStressLevel: { value: 'low', label: 'Low' },
        familyStructure: "Single",
        workEnvironment: { value: 'remote', label: 'Remote' },
        relationshipStatus: "Single",
        socialSupport: { value: 'moderate', label: 'Moderate' },
        communityEngagement: { value: 'active', label: 'Active' },
        therapyHistory: "No",
        majorLifeEvents: "Recent move to a new city, Job change",
        emotionalWellBeing: { value: 'stable', label: 'Stable' },
        // Biometric data fields as needed
        heartRate: 108.43,
        breathingRate: 26.66,
        hrv: 39.08,
        skinTemp: 35.68,
        emg: 0.65,
        bvp: 1.22,
        emotion: 'Fearful',
    },
    // Add more user objects with unique IDs as needed
};

// Function to get a specific user's data
export const getUserData = (userId) => {
    return users[userId];
};

// Function to get a list of all users
export const getAllUsers = () => {
    return Object.values(users);
};

export default users;
